export { TrendComponent } from './trend.component';
export { AdTrendModule } from './trend.module';
